import { AppUser } from "State/Auth/AuthReducer";
import { isNoU } from "Utils/ObjectUtils";

export const isNullOrEmpty = (value: unknown) => isNoU(value) || value === "";

export const getModifiedFirstName = (user: AppUser | null) => {
  let name = user?.firstName ?? "";
  name = name.trim();

  if (name === "Adam") {
    name = "Adame";
  }

  if (name === "Alena") {
    name = "Aleno";
  }

  if (name === "Alexandra") {
    name = "Alexandro";
  }

  if (name === "Andrea") {
    name = "Andreo";
  }

  if (name === "Barbora") {
    name = "Barboro";
  }

  if (name === "Bohumil") {
    name = "Bohumile";
  }

  if (name === "Daniel") {
    name = "Dane";
  }

  if (name === "Daniela") {
    name = "Danielo";
  }

  if (name === "David") {
    name = "Davide";
  }

  if (name === "Dominik") {
    name = "Dominiku";
  }

  if (name === "Dominika") {
    name = "Dominiko";
  }

  if (name === "Dušan") {
    name = "Dušane";
  }

  if (name === "Filip") {
    name = "Filipe";
  }

  if (name === "František") {
    name = "Františku";
  }

  if (name === "Gabriel") {
    name = "Gabo";
  }

  if (name === "Gabriela") {
    name = "Gabrielo";
  }

  if (name === "Hana") {
    name = "Hanko";
  }

  if (name === "Hynek") {
    name = "Hynku";
  }

  if (name === "Jakub") {
    name = "Jakube";
  }

  if (name === "Jan") {
    name = "Honzo";
  }

  if (name === "Jana") {
    name = "Jano";
  }

  if (name === "Jaroslav") {
    name = "Jaroslave";
  }

  if (name === "Jindřich") {
    name = "Jindřichu";
  }

  if (name === "Jozef") {
    name = "Jozefe";
  }

  if (name === "Josef") {
    name = "Josefe";
  }

  if (name === "Kamil") {
    name = "Kamile";
  }

  if (name === "Kamila") {
    name = "Kamilo";
  }

  if (name === "Karel") {
    name = "Karle";
  }

  if (name === "Lucie") {
    name = "Lucko";
  }

  if (name === "Lukáš") {
    name = "Lukáši";
  }

  if (name === "Marek") {
    name = "Marku";
  }

  if (name === "Martin") {
    name = "Martine";
  }

  if (name === "Martina") {
    name = "Martino";
  }

  if (name === "Matěj") {
    name = "Matěji";
  }

  if (name === "Michal") {
    name = "Michale";
  }

  if (name === "Michaela") {
    name = "Michaelo";
  }

  if (name === "Miloš") {
    name = "Miloši";
  }

  if (name === "Monika") {
    name = "Moniko";
  }

  if (name === "Patrik") {
    name = "Patriku";
  }

  if (name === "Pavel") {
    name = "Pavle";
  }

  if (name === "Pavla") {
    name = "Pavlo";
  }

  if (name === "Petr") {
    name = "Petře";
  }

  if (name === "Petra") {
    name = "Petro";
  }

  if (name === "Radek") {
    name = "Radku";
  }

  if (name === "Roman") {
    name = "Romane";
  }

  if (name === "Stanislav") {
    name = "Stanislave";
  }

  if (name === "Tereza") {
    name = "Terezo";
  }

  if (name === "Tomáš") {
    name = "Tome";
  }

  if (name === "Václav") {
    name = "Václave";
  }

  if (name === "Viktor") {
    name = "Viktore";
  }

  if (name === "Vojtěch") {
    name = "Vojtěchu";
  }

  if (name === "Zdeněk") {
    name = "Zdeňku";
  }

  if (user?.lastName === "Bardoděj") {
    name = "Juro";
  }

  return name;
};
